import React, { useMemo, useState } from "react";
import { Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { PagePanel, pageTypography } from "./PageLayout";

export default function VacationForm({ onSubmit, employees = [] }) {
  const [form, setForm] = useState({
    dipendenteId: "",
    type: "FERIE",
    startDate: "",
    endDate: "",
  });

  const isValid = useMemo(() => {
    return !!form.dipendenteId && !!form.startDate && !!form.endDate && form.endDate >= form.startDate;
  }, [form]);

  const updateField = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isValid) {
      return;
    }

    onSubmit(form);
    setForm({
      dipendenteId: "",
      type: "FERIE",
      startDate: "",
      endDate: "",
    });
  };

  return (
    <PagePanel component="form" onSubmit={handleSubmit} tone="warm" sx={{ p: 2.5 }}>
      <Typography sx={{ ...pageTypography.panelTitle, mb: 2 }}>
        Nuova richiesta ferie
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            select
            label="Dipendente"
            value={form.dipendenteId}
            onChange={updateField("dipendenteId")}
            fullWidth
          >
            {employees.map((employee) => (
              <MenuItem key={employee.id} value={String(employee.id)}>
                {employee.nome}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField select label="Tipo" value={form.type} onChange={updateField("type")} fullWidth>
            <MenuItem value="FERIE">Ferie</MenuItem>
            <MenuItem value="MALATTIA">Malattia</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            type="date"
            label="Dal"
            value={form.startDate}
            onChange={updateField("startDate")}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            type="date"
            label="Al"
            value={form.endDate}
            onChange={updateField("endDate")}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" disabled={!isValid}>
            Invia richiesta
          </Button>
        </Grid>
      </Grid>
    </PagePanel>
  );
}
